import React from "react";
import "../../styles/components/facultyProfile/workloadSection.scss";
import { Button, Table, Typography, Tag, Space, Popover } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";

export default function WorkloadSection({
  title,
  columns,
  data,
  selectedTerms,
  portfolioProps,
  onAdd,
  onEdit,
  children,
}) {
  const visibleCount = 2;
  const visibleTerms = selectedTerms.slice(0, visibleCount);
  const hiddenTerms = selectedTerms.slice(visibleCount);

  const filteredData = (data) =>
    selectedTerms.length === 0
      ? data
      : data.filter((item) => selectedTerms.includes(item.academic_term));

  return (
    <div className="workload-section">
      <div className="header">
        <div className="header-row">
          <Typography.Title
            level={3}
            style={{
              margin: 0,
              color: "#8b1438",
              fontFamily: "Palatino",
            }}
          >
            {title}
          </Typography.Title>
        </div>

        <div className="header-row">
          <div>
            <span className="filter-label">Academic Terms: </span>

            {selectedTerms.length === 0 ? (
              "All"
            ) : (
              <Space size={1} wrap>
                {visibleTerms.map((term) => (
                  <Tag key={term}>{term}</Tag>
                ))}

                {hiddenTerms.length > 0 && (
                  <Popover
                    trigger="hover"
                    placement="topLeft"
                    content={
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 6,
                        }}
                      >
                        {hiddenTerms.map((term) => (
                          <Tag key={term}>{term}</Tag>
                        ))}
                      </div>
                    }
                  >
                    <Tag style={{ cursor: "pointer" }}>
                      +{hiddenTerms.length}
                    </Tag>
                  </Popover>
                )}
              </Space>
            )}
          </div>

          <Button
            size="large"
            style={{ background: "#00573F" }}
            icon={<PlusCircleOutlined />}
            type="primary"
            onClick={onAdd}
          >
            Add
          </Button>
        </div>
      </div>

      {children ? (
        children
      ) : (
        <Table
          columns={columns}
          dataSource={filteredData(data)}
          scroll={{ x: "max-content" }}
          pagination={{ pageSize: 4 }}
          onRow={(record) => ({
            onClick: () => {
              if (onEdit) onEdit(record);
            },
            style: { cursor: "pointer" },
          })}
          rowKey={(record) => record.id}
        />
      )}
    </div>
  );
}
